<template>
  <!-- 角色管理 -->
  <div class="containerbox serverContent">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button class="itemBtn btnColor glo_bgcMainColor" @click="addServe()"
          >新建</el-button
        >
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="dtdc">导出</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <el-button class="itemBtn btnColor" @click="DelServe()">删除</el-button> -->
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        :showMoreBtns="false"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <div ref="queryForm">
      <el-form
        :model="queryData"
        :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'"
        label-position="left"
      >
        <el-form-item class="queryItems" label="角色:">
          <el-select
            filterable
            clearable
            v-model="queryData.roleName"
            placeholder="请选择"
            remote
            :loading="false"
            :remote-method="remoteMethod2"
            @change="changeTypeName"
          >
            <el-option
              v-for="(item, index) in roleLists"
              :key="index"
              :label="item.roleName"
              :value="item.roleName"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格:height="tableHeigth" -->
    <div class="glo_Table" ref="tableWrapper">
      <el-table
        ref="mytable"
        :data="tableData"
        :height="tableHeigth"
        :row-class-name="tableRowClassName"
        highlight-current-row
        @row-click="rowclick"
        :header-cell-style="{ background: '#f0f0f0' }"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column fixed="left" label="序号" type="index" width="60">
        </el-table-column>
        <el-table-column fixed="left" type="selection" width="60">
        </el-table-column>

        <template v-for="(item, index) in myTableHeard">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column
            v-if="item.field == 'userStatusShow'"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div
                style="color: #f00"
                v-if="scope.row.userStatus != 'zheng_chang:user_status'"
              >
                {{ scope.row.userStatusShow }}
              </div>
              <div v-else>{{ scope.row.userStatusShow }}</div>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          >
          </el-table-column>
        </template>
        <el-table-column fixed="right" label="操作" min-width="200px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button
                class="rbtns"
                @click.stop="editorServe(scope.row.roleId)"
                >编辑</el-button
              >
              <el-button
                class="rbtns"
                @click.stop="AssignMent(scope.row.roleId)"
                >分配权限</el-button
              >
              <el-button class="rbtns" @click.stop="DelServe(scope.row.roleId)"
                >删除</el-button
              >
              <!-- 如果按钮超过4个就要用下面这种下拉的样式 -->
              <!-- <el-dropdown
                class="rbtns"
                @command="handleCommandBtns($event, scope.row)"
              >
                <el-button type="primary">
                  更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">修改密码</el-dropdown-item>
                  <el-dropdown-item command="b">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页组件 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :sizeList="sizeList"
      :size="pageTotal"
      class="serverPage"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>

    <!-- 新建弹窗 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="handleCloseDia"
      @diaConfirmBtn="diaConfirmBtn('dialogFormRef')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          ref="dialogFormRef"
          v-if="isShowDialog"
          :model="dialogForm"
          label-width="100px"
          :rules="rulesForm"
        >
          <el-form-item class="dialogFormItems" prop="roleName" label="角色:">
            <el-input
              v-model="dialogForm.roleName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="sort" label="排序:">
            <el-input v-model="dialogForm.sort" placeholder="请输入"></el-input>
          </el-form-item>

          <el-form-item class="dislogFormTextarea" prop="comment" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm.comment"
            ></el-input>
          </el-form-item>
          <!-- <div class="diaForm" v-if="dialogType == 'edit'">
            <el-form-item class="dialogFormItems" prop="aaa" label="新建人:">
              <el-input
                v-model="dialogForm.aaa"
                placeholder="自动带出"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item class="dialogFormItems" prop="aaa" label="新建时间:">
              <el-input
                v-model="dialogForm.aaa"
                placeholder="自动带出"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item class="dialogFormItems" prop="aaa" label="修改人:">
              <el-input
                v-model="dialogForm.aaa"
                placeholder="自动带出"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item class="dialogFormItems" prop="aaa" label="修改时间:">
              <el-input
                v-model="dialogForm.aaa"
                placeholder="自动带出"
                disabled
              ></el-input>
            </el-form-item>
          </div> -->
        </el-form>
      </div>
    </myDialog>

    <!-- 修改密码 -->
    <myDialog
      :diaWidth="diaWidth2"
      :dialogTitle="dialogTitle2"
      :isShowDialog="isShowDialog2"
      @handleCloseDia="handleCloseDia2"
      @diaCancelBtn="diaCancelBtn2"
      @diaConfirmBtn="diaConfirmBtn2('dialogForm2Ref')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          v-if="isShowDialog2"
          ref="dialogForm2Ref"
          :model="dialogForm2"
          label-width="100px"
          :rules="rulesForm2"
        >
          <el-form-item
            class="dialogFormItems"
            style="margin: 70px auto"
            prop="aaa"
            label="新密码:"
          >
            <el-input v-model="dialogForm.aaa" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    >
    </sorttable>
    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 当前页面的查询条件 -->
      <div ref="queryForm">
        <el-form :model="queryData" class="glo_form hasMoreParam" label-position="left">
          <el-form-item class="queryItems" label="角色:">
          <el-select
            filterable
            clearable
            v-model="queryData.roleName"
            placeholder="请选择"
            remote
            :loading="false"
            :remote-method="remoteMethod2"
            @change="changeTypeName"
          >
            <el-option
              v-for="(item, index) in roleLists"
              :key="index"
              :label="item.roleName"
              :value="item.roleName"
            ></el-option>
          </el-select>
          </el-form-item>
        </el-form>
      </div>
    </exportCompoent>
  </div>
</template>

<script>
// import { apiList, this.$API } from "@/assets/js/api";
// import tools from "@/assets/js/tool";
import paging from "@/components/pagings.vue";
import myDialog from "@/components/Dialog.vue";
import queryBtns from "@/components/queryBtns.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
export default {
  mixins: [exportjs],
  inject: ["reload"],
  components: {
    queryBtns,
    myDialog,
    paging,
    uploadimgs,
    sorttable,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "角色管理", //导出时默认文件名
        apiName: "/v1/admin/role/roleList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      pageStart: 1, //页码
      pageTotal: this.$COMMON.pageTotals, //一页几条,
      pageCount: 0, //总条数
      sizeList: [10, 20, 50, 100, 200],
      tableHeigth: "75vh",
      selectTableData: [],

      queryData: { roleName: "" },
      MoreConditions: "更多条件", //  输入框绑定动态class
      isHaseMore: false, //false == 更多条件  true ==收起条件

      // ==== 弹窗组件属性 start ====
      isShowDialog: false,
      dialogTitle: "弹窗标题",
      dialogType: "add",
      diaWidth: "60%",
      dialogForm: {
        // 弹窗表单数据
        roleName: "",
        sort: "",
        comment: "",
      },
      rulesForm: {
        roleName: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        sort: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },

      isShowDialog2: false,
      dialogTitle2: "修改密码",
      diaWidth2: "30%",
      dialogForm2: {
        // 弹窗表单数据
        aaa: "",
        bbb: "",
        ccc: "",
      },
      rulesForm2: {
        aaa: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },

      // 默认表头
      tabelHeadeTitle: [
        {
          name: "角色",
          field: "roleName",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "排序",
          field: "sort",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "备注",
          field: "comment",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "新建人",
          field: "",
          width: "120",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "新建时间",
          field: "createTime",
          width: "160",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "修改人",
          field: "",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "修改时间",
          field: "updateTime",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],
      myTableHeard: [], //  我的表头
      tableData: [], //  表格数据
      show_sortTableHeard: false, //显示表格设置弹窗
      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      allCheck: false, //  全选
      selectLength: 0, //  显示的长度
      totalArr: [], //  表格需要合计的字段
      className: "", //  导出需要
      pageGroupName: "RoleManagement", //  页面标识
      sortName: "角色管理模板", //  排序名

      // upLoadUrl: this.$COMMON.uploadUrl,
      fileNameLists: [],
      pageType: "add",

      roleLists: [],
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.myTableHeard = this.tabelHeadeTitle;
    if (this.originalTabelHeadeTitle.length === 0) {
      this.originalTabelHeadeTitle = JSON.parse(
        JSON.stringify(this.tabelHeadeTitle)
      );
    }

    //获取默认表头 页面有这四个字段 myTableHeard,sortName,tabelHeadeTitle,totalArr
    this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
  },
  mounted() {
    this.getData();
    this.remoteMethod2();
  },
  activated() {
    this.$nextTick(() => {
      this.fetTableHeight();
    });
  },
  watch: {},
  methods: {
    // 获取角色下拉列表
    remoteMethod2(typeName) {
      let that = this;
      let param = {
        pageStart: 1,
        pageTotal: 100,
        roleName: typeName || this.queryData.typeName,
      };
      this.$API.wtl_roleList(param).then((res) => {
        that.roleLists = res.data.result.data || [];
      });
    },
    // 查询条件
    changeTypeName(e) {
      if (!e) {
        this.remoteMethod2();
      }
      this.queryBtn_ok();
    },
    //点击更多操作下的按钮
    handleCommandBtns(type, val) {
      // a==修改密码
      if (type === "a") {
        this.isShowDialog2 = true;
      }
      // d==删除
      if (type === "d") {
      }
    },

    //顶部跟多按钮的操作
    topCommandBtns(a) {
      if (a === "bgsz") {
        // 设置模板按钮
        // this.myModel();
        this.$TOOLS.myModel(this);
      }
      if (a === "dyyd") {
        // 打印运单
      }
      if (a === "dybq") {
        // 打印标签
      }
      if (a === "dr") {
        // 导入
      }
      if (a === "dtdc") {
        // 导出
        // this.exportBtn();
        this.isShowDialog_dc = true;
      }
    },
    // 点击导出 (页面标识,表头,列表标识,数据源,表名)
    exportBtn() {
      this.$COMAPI.exportBtn({
        pageGroupName: this.pageGroupName, //页面标识
        myTableHeard: this.myTableHeard, //表头数组
        className: this.className, //列表标识
        tableData: this.tableData, //数据源
        sheetName: "表名(暂无效)", //表名
      });
    },
    queryBtn_ok() {
      //  查询按钮
      this.pageStart = 1;
      this.getData();
    },

    clerBtns() {
      //  重置按钮
      this.queryData = {
        roleName: "",
      };
    },

    moreParam() {
      this.isHaseMore = !this.isHaseMore;
      if (this.isHaseMore) {
        this.MoreConditions = "收起条件";
      } else {
        this.MoreConditions = "更多条件";
      }

      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },

    // 删除
    DelServe(id) {
      this.$confirm("该操作将删除该角色,请谨慎操作!", "提示:")
        .then((res) => {
          let ids = [id];
          this.$API.wtl_deleteRole({ roleIds: ids }).then((res) => {
            this.$message.success(res.data.message || "操作成功");
            this.getData();
            this.remoteMethod2();
          });
        })
        .catch(() => {});
    },
    aaaaaa() {},
    // 分配权限
    AssignMent(id) {
      this.$router.push({
        path: "/SystemSetting/PermissionAssignmentRole",
        query: {
          nid: id,
        },
      });
    },
    // 新建版本
    addServe() {
      this.isShowDialog = true;
      this.dialogTitle = "新建角色";
      this.dialogType = "add";
    },
    // 编辑
    editorServe(id) {
      this.$API.wtl_roleDetail({ roleId: id }).then((res) => {
        this.dialogForm = res.data.result || {};
        this.isShowDialog = true;
        this.dialogTitle = "编辑角色";
        this.dialogType = "edit";
      });
    },

    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },

    //=>选择表格操作
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    //表格样式i
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
    },
    /**
     * ******************************计算表格高度**开始*************************
     */
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let queryHeigth = 40 + 10; //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList.offsetHeight; // 按钮列表高度
      if (this.isHaseMore) {
        queryHeigth = this.$refs.queryForm.offsetHeight + 10; //查询框
      }
      let pagsHeigth = 40 + 20; //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60; //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //

      this.$nextTick(() => {
        this.tableHeigth = tabHeight;
        this.$refs.mytable.doLayout();
      });
    },
    /**
     * ******************************计算表格高度**结束*************************
     */

    //分页
    handleSizeChange(val) {
      this.pageTotal = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageStart = val;
      this.getData();
    },
    // 获取数据
    getData() {
      let that = this;
      let param = {
        pageStart: this.pageStart,
        pageTotal: this.pageTotal,
        roleName: this.queryData.roleName,
      };
      this.$API.wtl_roleList(param).then((res) => {
        that.className = res.data.result.className || "";
        that.tableData = res.data.result.data || [];
        that.pageCount = res.data.result.pageCount || 0;
        that.fetTableHeight();
      });
    },

    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false;
      this.dialogForm = {
        roleName: "",
        sort: "",
        comment: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn(formName) {
      this.isShowDialog = false;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            roleName: this.dialogForm.roleName || "",
            sort: this.dialogForm.sort || "1",
            comment: this.dialogForm.comment || "",
          };
          if (this.dialogType == "add") {
            // 新建
            this.$API.wtl_addRole(param).then((res) => {
              this.$message.success(res.data.message || "新建成功");
              this.getData();
            });
          } else {
            // 编辑
            param.isSuper = 0; //这个字段是多余的,但是要跟后台一致,不能删
            param.roleId = this.dialogForm.roleId;
            this.$API.wtl_updateRole(param).then((res) => {
              this.$message.success(res.data.message || "修改成功");
              this.getData();
            });
          }
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false;
    },

    handleCloseDia2() {
      this.isShowDialog2 = false;
    },
    //  弹窗确认保存事件
    diaConfirmBtn2() {
      this.isShowDialog2 = false;
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn2() {
      this.isShowDialog2 = false;
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    /***
     * ====== 弹窗组件方法 ======
     */

    // ===================排序表头彈窗的组件方法 start ===================
    //   取消按钮(表格设置)
    cancelSortHeard() {
      this.show_sortTableHeard = false;
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
    },
    // 排序==>确认按钮(表格设置)
    confirmOk(e) {
      this.tabelHeadeTitle = e;
      this.myTableHeard = this.tabelHeadeTitle;
      let sortObject = this.myTableHeard;
      let param = {
        groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        sortName: this.sortName, //综合查询接口路径
        sortObject: JSON.stringify(sortObject),
      };
      this.$API.pushFindFieldSort(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        //获取默认表头
        this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
      });
      this.show_sortTableHeard = false; //关闭弹窗
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      this.show_sortTableHeard = false;
    },
    // 点击某一项(表格设置)
    checktab(idx, e) {
      let that = this;
      that.tabelHeadeTitle[idx].isShow = e;
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },
    //全选(表格设置)
    checkAll(e) {
      let that = this;
      this.allCheck = e;
      for (var j = 0; j < this.tabelHeadeTitle.length; j++) {
        this.tabelHeadeTitle[j].isShow = e;
      }
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
    },
    //关闭弹窗(表格设置)
    closeDias(e) {
      this.show_sortTableHeard = e;
    },

    /****
     *  ===================排序表头彈窗的组件方法 end ===================
     *
     */
  },
};
</script>

<style scoped lang="less">
// .containerbox {
//   height: calc(100vh - 75px);
// }

// .tableBox {
//   height: calc(100% - 180px);
// }
.colorStyle {
  color: #f00;
}
.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}
.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }
  .timeBox {
    border: 1px solid #d7d7d7;
  }
}
.headerbox {
  width: 100%;
  display: flex;
  justify-content: center;
}
.imgbox {
  width: 100%;
  margin-left: 12%;
  box-sizing: border-box;
}
.footerbox {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 50px;
}
.newForm {
  margin-left: 80px;
  .queryItem1 {
    width: 60%;
    margin-top: 20px;
  }
}
.singleinp1 {
  min-width: 392px;
}
.HeadInputbox .item_right .singleinp1 .el-date-editor.el-input,
.HeadInputbox .item_right .singleinp1 .el-date-editor.el-input__inner {
  width: 100%;
}
.SingleChoicebox {
  width: 100%;
  padding: 0 20px;
  margin-top: 20px;
  box-sizing: border-box;
}
.el-input-number {
  width: 100%;
  height: 30px;
  line-height: 30px;
}
.serverContent {
  .tableBox {
    background-color: #fff;
  }
  .btnList1 {
    width: auto;
    // padding: 10px;
    border-radius: 4px;
  }
}
</style>
